import Plans from 'screens/Plans';
import Plan from 'screens/Plans/Plan';
import { paths } from 'routes/paths';
import { ROLES } from 'utilities/access';
import PlanViewGuard from './PlanViewGuard';
import PlanFormRouteGuard from './PlanFormRouteGuard';

const navRoutes = [
  {
    id: 'plans',
    key: 'plans',
    label: 'Plans',
    path: paths.plans,
    exact: true,
    secure: true,
    disabled: false,
    component: Plans
  }
];
const allRoutes = [
  ...navRoutes,
  // `planCreate` MUST precede `planEntry` below: both are exact, single-
  // segment routes, and `Switch` renders whichever matches first — `:id`
  // would otherwise swallow `/create` first (`id: 'create'`).
  {
    id: 'planCreate',
    key: 'planCreate',
    path: `${paths.plans}/create`,
    exact: true,
    secure: true,
    disabled: false,
    component: PlanFormRouteGuard,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'planEdit',
    key: 'planEdit',
    path: `${paths.plans}/:id/edit`,
    exact: true,
    secure: true,
    disabled: false,
    component: PlanFormRouteGuard,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'planEntry',
    key: 'planEntry',
    path: `${paths.plans}/:id`,
    exact: true,
    secure: true,
    disabled: false,
    component: Plan,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'planView',
    key: 'planView',
    path: `${paths.plans}/:id/view`,
    exact: true,
    secure: true,
    disabled: false,
    component: PlanViewGuard
  }
];

export default { navRoutes, allRoutes };
